module.exports = __webpack_public_path__ + "fonts/ZhanKuKuHei-1.5a389666.ttf";